import http from '@root/utils/axios/admin';

let state = {
    GpusList: [],
    CpusList: [],
    RamsList: [],
    GameCategoriesList: [],
    ProfileStatistics: {},
    ContactError: {},
    MainVideo: {}

}

let actions = {

    fetchMainVideo({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/main-video', { params: filter }).then((response) => {
                commit('setMainVideo', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchCpusList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('get-cpus', { params: filter }).then((response) => {
                commit('setCpusList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchRamsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('get-rams', { params: filter }).then((response) => {
                commit('setRamsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchGameCategoriesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('get-game-categories', { params: filter }).then((response) => {
                commit('setGameCategoriesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    setMostPopular({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/set-most-popular', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },

    fetchProfileStatistics({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/profile-statistics', { params: filter }).then((response) => {
                commit('setProfileStatistics', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    contactUs({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/contact-us', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setContactError', error.response.data);
                }
                reject(error);
            })
        });
    },



}


let mutations = {
    setMainVideo(state, data) {
        state.MainVideo = data;
    },
    setGpusList(state, data) {
        state.GpusList = data;
    },
    setCpusList(state, data) {
        state.CpusList = data;
    },
    setRamsList(state, data) {
        state.RamsList = data;
    },
    setGameCategoriesList(state, data) {
        state.GameCategoriesList = data;
    },
    setProfileStatistics(state, data) {
        state.ProfileStatistics = data;
    },
    setContactError(state, error) {
        state.ContactError = error.errors;
    },

}

export default {
    state,
    actions,
    mutations
}